export default "__VITE_ASSET__Cg7MM6fm__"